import React, { useState } from 'react';
import axios from 'axios';
import './LoginForm.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginForm = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [serverResponse, setServerResponse] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}api/accounts/token/`, {
                email: username,  // 👈 send "email", not "username"
                password,
            });
            localStorage.setItem('accessToken', response.data.access);
            localStorage.setItem('refreshToken', response.data.refresh);
            const { access } = response.data;
            onLogin(access);
            setServerResponse('Login successful!');
        } catch (error) {
            setServerResponse('Login failed. Please check your credentials and try again.');
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="logo-container">
                    <img
                        src={`${process.env.PUBLIC_URL}/static/img/component-3-8.png`}
                        alt="The Mamahood"
                        className="logo"
                    />STRATAGEM
                    <h1 className="title">Welcome</h1>
                </div>
                <h2>Log in to your account</h2>
                <p className="subtitle">Strata AI personal assistant</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash size={20}/> : <FaEye size={20}/>}
                            </button>
                        </div>
                    </div>
                    {serverResponse && (
                        <div className="form-error">{serverResponse}</div>
                    )}
                    <button type="submit" className="login-button">
                        Login
                    </button>
                </form>
                <div className="forgot-password">
                    <a href="#">Forgot password?</a>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;